import Avatar from "components/Home/ui/Avatar";
import React, { useEffect, useRef, useState } from "react";
import EfficeTitlePresence from "components/Home/ui/EfficeTitlePresence";
import {
  determineTextColor,
  getDateFromTimestamp,
  getHourFromTimestamp,
  LinkifyMe,
} from "helpers/efficeHelpers";
import MessageSendFailure from "../MessageSendFailure/MessageSendFailure";
import Editor from "../../../../../InfoPage/InfoText/Editor/Editor";
import EdittingText from "../../../../../InfoPage/InfoText/EdittingText/EdittingText";
import { getPersonName } from "helpers/randomHelpers";

const NormalDetailed = ({ myId, efficeData, ppl }) => {
  const ref = useRef();
  const [loading, setLoading] = useState(false);
  const [editting, setEditting] = useState(false);
  const [content, setContent] = useState(false);
  useEffect(() => {
    // console.log("USEFEFEF");
    if (ref.current) {
      // console.log("REF CURRENT");
      // console.log(ref.current.scrollHeight);
      // console.log(ref.current);
      // ref.current.scrollTop = ref.current.scrollHeight;
      //ref.current.style.height = "35px";
      ref.current.style.height = ref.current.scrollHeight + 2 + "px";
    }
  }, [content, editting]);

  return (
    <>
      <div className="Txt-effice-left-side">
        {ppl > 0 ? (
          <div className="detailed-presence-margin">
            <EfficeTitlePresence ppl={ppl} large={true} />
          </div>
        ) : (
          <div className="Txt-avatar">
            <Avatar
              avatar_key={efficeData.creator.avatar_key}
              given_name={efficeData.creator.given_name}
              family_name={efficeData.creator.family_name}
            />
          </div>
        )}
      </div>
      <div className="Txt-effice-middle-content">
        <div>
          <div className="Txt-effice-creator-name">
            {getPersonName(
              efficeData.creator.given_name,
              efficeData.creator.family_name
            )}
            &nbsp;{/* So copy past looks neater */}
          </div>
          <div className="Txt-effice-time-font">
            {`${getDateFromTimestamp(
              efficeData.created_at
            )} at ${getHourFromTimestamp(efficeData.created_at)}`}
            {efficeData.editted_at ? (
              <span className="Txt-edited-font">&emsp; - Edited</span>
            ) : null}
            {efficeData.creator.id === myId && (
              <Editor
                effId={efficeData.id}
                originalContent={efficeData.content}
                loading={loading}
                setLoading={setLoading}
                content={content}
                setContent={setContent}
                editting={editting}
                setEditting={setEditting}
              />
            )}
          </div>
        </div>
        <div className={determineTextColor(efficeData)}>
          {editting ? (
            <EdittingText
              elem={ref}
              content={content}
              setContent={setContent}
              loading={loading}
            />
          ) : (
            <LinkifyMe>{efficeData.content}</LinkifyMe>
          )}

          {efficeData.failed ? <MessageSendFailure /> : null}
        </div>
      </div>
    </>
  );
};

export default NormalDetailed;
